import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  margin: 0 auto;
  height: 100%;
  max-width: 1142px;
  padding: ${theme.spacing(3)};
`

export const header = (theme: Theme) => css`
  padding: ${theme.spacing(1, 0)};

  font-weight: 700;
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(6, 0, 2)};
`

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(3)};
  margin-top: ${theme.spacing(3)};
`
